module.exports = __webpack_public_path__ + "img/glossel.7763aaea.svg";